import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Spinner,
  VStack,
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import useTestStore from '../../../store/testStore';
import { getTests, searchTests } from '../../../api/tests';
import { useNavigate } from 'react-router-dom';
import { TestCard } from './TestCard';
import useStore from '../../../store/store';
import { SearchIcon } from '@chakra-ui/icons';
import { InputGroup, InputLeftElement, Text } from '@chakra-ui/react';

export const PopularTests = () => {
  const { tests, setTests } = useTestStore();
  const { setLoading, loading } = useStore();

  const navigate = useNavigate();

  React.useEffect(() => {
    import('@lottiefiles/lottie-player');
  }, []);

  const fetchData = React.useCallback(async () => {
    try {
      setLoading(true);
      const res = await getTests();
      setTests(res);
    } catch (error) {
      console.log('error in loading tests', error);
    } finally {
      setLoading(false);
    }
  }, [setLoading, setTests]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearch = async e => {
    e.preventDefault();
    const res = await searchTests(e.target.value);
    setTests(res);
  };

  return (
    <VStack
      p={[5, 12]}
      spacing={[12]}
      height={'full'}
      id="tests"
      width="full"
      position="relative"
      overflow="hidden"
    >
      {/* Background Decorative Element */}
      <Box
        position="absolute"
        top="-10%"
        right="-5%"
        width="300px"
        height="300px"
        bg="teal.50"
        borderRadius="full"
        filter="blur(80px)"
        zIndex={-1}
        opacity={0.6}
      />
      <Box
        position="absolute"
        bottom="10%"
        left="-5%"
        width="250px"
        height="250px"
        bg="blue.50"
        borderRadius="full"
        filter="blur(80px)"
        zIndex={-1}
        opacity={0.5}
      />

      <Flex flexDir={'column'} gap={[6, 8]} alignItems={'center'} width="full">
        <VStack spacing={2}>
          <Heading
            bgGradient="linear(to-r, teal.600, blue.500)"
            bgClip="text"
            fontSize={[32, 42]}
            fontWeight="bold"
            textAlign="center"
          >
            Popular Diagnostic Tests
          </Heading>
          <Text color="gray.500" fontSize={['sm', 'md']} textAlign="center" fontWeight="medium">
            Book top-rated health checkups from the comfort of your home
          </Text>
        </VStack>

        <InputGroup width={['90vw', '45vw']} size="lg">
          <InputLeftElement pointerEvents="none">
            <SearchIcon color="teal.500" />
          </InputLeftElement>
          <Input
            variant="filled"
            placeholder="Search for a test (e.g. CBC, Lipid Profile)"
            bg="white"
            borderRadius="full"
            boxShadow="0 4px 12px rgba(0,0,0,0.05)"
            _focus={{
              bg: 'white',
              boxShadow: '0 0 0 3px rgba(49, 151, 149, 0.2)',
              borderColor: 'teal.400',
            }}
            _hover={{
              bg: 'gray.50',
            }}
            onChange={handleSearch}
          />
        </InputGroup>
      </Flex>

      <Box width="full" px={[0, 10]}>
        <Box
          display="grid"
          gridTemplateColumns={['1fr', '1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)']}
          gap={[6, 8]}
          width="full"
          justifyContent="center"
        >
          {loading ? (
            <Flex width="full" height="40vh" alignItems="center" justifyContent="center" gridColumn="1 / -1">
              <Spinner
                size={'xl'}
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.100"
                color="teal.500"
              />
            </Flex>
          ) : (
            <>
              {tests.slice(0, 6).map((test) => {
                return <TestCard test={test} key={test._id || test.id} />;
              })}
            </>
          )}
        </Box>
      </Box>

      <Button
        variant={'outline'}
        colorScheme={'teal'}
        size="lg"
        borderRadius="full"
        px={10}
        onClick={() => navigate('/tests')}
        _hover={{
          bg: 'teal.500',
          color: 'white',
          transform: 'translateY(-2px)',
          boxShadow: 'lg',
        }}
        transition="all 0.3s"
      >
        View All 100+ Tests
      </Button>
    </VStack>
  );
};
